(function () {
  if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;

  var hint = document.createElement('div');
  hint.className = 'mercury-cursor-hint';
  hint.textContent = 'View';
  document.body.appendChild(hint);

  function moveHint(e) {
    hint.style.left = e.clientX + 'px';
    hint.style.top = e.clientY + 'px';
  }

  document.querySelectorAll('media-gallery .product-media-container, media-gallery img').forEach(function (el) {
    el.classList.add('mercury-cursor-zoom');
    el.addEventListener('mouseenter', function () {
      hint.classList.add('is-visible');
    });
    el.addEventListener('mouseleave', function () {
      hint.classList.remove('is-visible');
    });
    el.addEventListener('mousemove', moveHint);
  });
})();
